import React from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../Rever_Logo_Footer.png";
import facebookLogo from "../assets/Icons/fb.svg";
import instaLogo from "../assets/Icons/insta.svg";
import youtubeLogo from "../assets/Icons/youtube.svg";
import "./footer.scss";

export default function Footer() {
  return (
    <footer className="footer container-fluid">
      <div className="top-section">
        <ul>
          <li>
            <Link className="footerList-head" to="/">
              RHS
            </Link>
            <div className="contact-number">
              <a href="/">About</a>
              <a href="/">Medical Tips</a>
              <a href="/">Press</a>
              <a href="/">Contact Us</a>
            </div>
          </li>
          <li>
            <Link className="footerList-head" to="/about">
              For Patients
            </Link>
            <div className="contact-number">
              <a href="/">Search For Doctors</a>
              <a href="/">Search For Clinics</a>
              <a href="/">Search For Hospitals</a>
              <a href="/">Book Diagnostics Tests</a>
              <a href="/">Book Full Body Checkups</a>
              <a href="/">Book Ambulence Services</a>
              <a href="/">Book Your Medical Tourism</a>
              <a href="/">Book Your Physiotherapists</a>
              <a href="/">Book Your Blood Sample collection</a>
              <a href="/">RHS Membership Card</a>
              <a href="/">Read Health Articles</a>
              <a href="/">Read About Medicines</a>
            </div>
          </li>
          <li>
            <Link to="/" className="footerList-head">Signup Profile</Link>
            <div className="contact-number">
              <a href="/">For Doctors</a>
              <a href="/">For Hospitals</a>
              <a href="/">For Diagnostics Clinics</a>
              <a href="/">For Ambulance Provider</a>
              <a href="/">For Nurse</a>
              <a href="/">For Physiotherapists</a>
            </div>
          </li>
          <li>
            <Link to="/" className="footerList-head">Medical Tourism</Link>
          </li>
          <li>
            <a href="/" className="footerList-head">For Corporates</a>
            <div className="contact-number">
              <a href="/">FAQ</a>
              <a href="/">Privacy Pocily</a>
              <a href="/terms&conditions">Terms & Conditions</a>
              <a href="/">RHS T&C</a>
            </div>
          </li>
          <li>
            <a href="/" className="footerList-head">Social</a>
            <div className="social-icons">
              <a
                target="_blank"
                href="https://www.facebook.com/reverhealthsolution"
                rel="noreferrer"
              >
                <img src={facebookLogo} alt="Rever Health Facebook"></img>
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/reverhealthsolution/"
                rel="noreferrer"
              >
                <img src={instaLogo} alt="Rever Health Instagram"></img>
              </a>
              <a
                target="_blank"
                href="https://www.youtube.com/results?search_query=reverhealth+solution"
                rel="noreferrer"
              >
                <img src={youtubeLogo} alt="Rever Health Instagram"></img>
              </a>
            </div>
          </li>
        </ul>
      </div>
      <div className="bottom-section">
        <img src={logo} alt="Rever Health Solution"></img>
        <a href="/">© 2024 Rever Health Solution, Kolkata-700042, India</a>
      </div>
    </footer>
  );
}
